import axiosPlataformaClient from '../../../plugins/axios.plataforma.plugin';

export default {
  getTopicContent({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}/topic/${topicId}`);
  },
  getPageChildrensContent({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}/page/${topicId}`);
  },
  getPostsByTopicId({ enrollmentId, topicId }) {
    return axiosPlataformaClient.custAxios().get(`/content/enrollment/${enrollmentId}/topic/${topicId}/post`);
  }
};
